export const underRevision = "Under Revision";

export const approved = "Approved";

export const denied = "Denied";

export const requestedRenditionExtension = "RequestedRenditionExtension";
